import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CalculatorComponent } from './components/calculator/calculator.component';
import { IsInIframeGuard } from './guards/is-in-iframe.guard';

const routes = [{ path: '**', component: CalculatorComponent, canActivate: [IsInIframeGuard] }];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [IsInIframeGuard],
})
export class AppRoutingModule {}
